import { useLayoutEffect, useRef } from 'react'

import { IconLoader2 } from '@tabler/icons-react'

function alignToDocumentTimeline(element: Element | null) {
  if (!element || typeof element.getAnimations !== 'function') return

  for (const animation of element.getAnimations()) {
    animation.startTime = 0
  }
}

export function BootSpinner() {
  const iconRef = useRef<SVGSVGElement>(null)

  useLayoutEffect(() => {
    alignToDocumentTimeline(iconRef.current)
  }, [])

  return (
    <div className="bg-background fixed inset-0 z-50 flex items-center justify-center">
      <IconLoader2 ref={iconRef} className="text-link h-8 w-8 animate-spin" />
    </div>
  )
}
